import request from "@/utils/request";
export function save(data) {
    return request({
        url: '/api/portal/v1/portalCompany/addPortalCompany',
        method: 'post',
        data
    })
}
export function list(data) {
    return request({
        url: '/api/portal/v1/portal/selectColumnNewsInfo',
        method: 'post',
        data
    })
}